import React, {Component, Fragment} from 'react'
import {
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Button,
    Table,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap'
import autobind from 'auto-bind'

import CustomSelectInput from 'components/CustomSelectInput'

import * as API from 'SDK/api'

export default class extends Component {
    constructor(props) {
        super(props)
        autobind(this)
    }
    async remove() {
        if (!(await API.remove('users/' + this.props.editingUser._id, 2))) {
            return alert(
                'There was an error deleting this user. Please try again.'
            )
        } else {
            this.props.toggleModal('removeModal')
        }
    }

    render() {
        let {modal, toggleModal, editingCode} = this.props
        return (
            <Fragment>
                <Modal
                    isOpen={modal}
                    toggle={() => {
                        toggleModal('removeModal')
                    }}>
                    <ModalHeader
                        toggle={() => {
                            toggleModal('removeModal')
                        }}>
                        Remove User
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col xs="12">
                                <p>
                                    Are you sure you want to remove this user?
                                </p>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="secondary"
                            onClick={() => {
                                toggleModal('removeModal')
                            }}>
                            Cancel
                        </Button>
                        <Button color="danger" onClick={this.remove}>
                            Remove
                        </Button>
                    </ModalFooter>
                </Modal>
            </Fragment>
        )
    }
}
